<template>
    <section class="app-sidebar left-sidebar">
        <nav class="sidebar sidebar-offcanvas" id="sidebar">
            <ul class="nav">
                <li class="nav-item new-nav-item">
                    <span class="nav-link" v-b-toggle="'nav-profile-img'">
                        <div class="nav-profile-img">
                            <img :src="`${url}images/profile/${Image}`" alt="image">
                        </div>
                        <div class="info">
                            <b class="caret pull-right"></b>
                            <div class="position">{{ this.FirstName }}</div>
                        </div>
                    </span>
                    <i class="menu-arrow"></i>
                    <b-collapse accordion="sidebar-accordion" id="nav-profile-img">
                        <ul class="nav flex-column sub-menu">
                            <li class="nav-item">
                                <b-dropdown-item class="preview-item">
                                    <router-link :to="{ name: 'settings' }">
                                        <i class="ti-settings text-primary"></i> Settings
                                    </router-link>
                                </b-dropdown-item>
                            </li>
                            <li class="nav-item">
                                <b-dropdown-item class="preview-item" @click="logout()">
                                    <i class="ti-power-off text-primary"></i> Logout
                                </b-dropdown-item>
                            </li>
                        </ul>
                    </b-collapse>
                </li>
                <li class="nav-header">Main Menu</li>
                <li class="nav-item" v-on:click="collapseAll">
                    <router-link class="nav-link" :to="{ name: 'dashboard' }">
                        <i class="menu-icon new-menu-icon  fa fa-home"></i>
                        <span class="menu-title">Dashboard</span>
                    </router-link>
                </li>

                <li class="nav-item">
                    <span class="nav-link" v-b-toggle="'dashboards'">
                        <i class="fa fa-users new-menu-icon menu-icon"></i>
                        <span class="menu-title">Members</span>
                        <i class="menu-arrow"></i>
                    </span>
                    <b-collapse accordion="sidebar-accordion" id="dashboards">
                        <ul class="nav flex-column sub-menu">
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'add_member' }">Add Member</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'ViewMember' }">View
                                    Member</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'MemberFocuses' }">Member
                                    Focuses</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'Position' }">Position</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'Status' }">Status</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'Billing' }">Billing</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'add_transaction' }">Member
                                    Transaction</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'file_download' }">File
                                    Downloads</router-link>
                            </li>
                        </ul>
                    </b-collapse>
                </li>

                <li class="nav-item">
                    <span class="nav-link" v-b-toggle="'RSVP'">
                        <i class="fa fa-users new-menu-icon menu-icon"></i>
                        <span class="menu-title">RSVP</span>
                        <i class="menu-arrow"></i>
                    </span>
                    <b-collapse accordion="sidebar-accordion" id="RSVP">
                        <ul class="nav flex-column sub-menu">
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'rsvp_calendar' }">RSVP Calendar</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'rsvp_attendees' }">RSVP Attendees</router-link>
                            </li>
                        </ul>
                    </b-collapse>
                </li>

                <li class="nav-item">
                    <span class="nav-link" v-b-toggle="'dashboards1'">
                        <i class="fa fa-users new-menu-icon menu-icon"></i>
                        <span class="menu-title">Survey</span>
                        <i class="menu-arrow"></i>
                    </span>
                    <b-collapse accordion="sidebar-accordion" id="dashboards1">
                        <ul class="nav flex-column sub-menu">
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'add_survey' }">Add Survey</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'edit_survey' }">Edit Survey</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'send_survey' }">Send Survey</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'completed_survey' }">Completed
                                    Survey</router-link>
                            </li>
                        </ul>
                    </b-collapse>
                </li>
                <li class="nav-item" v-on:click="collapseAll">
                    <router-link class="nav-link" :to="{ name: 'webinar_information' }">
                        <i class="menu-icon new-menu-icon fa fa-video-camera"></i>
                        <span class="menu-title">Webinar Information</span>
                    </router-link>
                </li>
                <li class="nav-item" v-on:click="collapseAll">
                    <router-link class="nav-link" :to="{ name: 'admin_calendly_events' }">
                        <i class="menu-icon new-menu-icon fa fa-clock-o"></i>
                        <span class="menu-title">Calendly Availability</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <span class="nav-link" v-b-toggle="'email-markeeting'">
                        <i class="fa fa-envelope new-menu-icon menu-icon"></i>
                        <span class="menu-title">Email Marketing</span>
                        <i class="menu-arrow"></i>
                    </span>
                    <b-collapse accordion="sidebar-accordion" id="email-markeeting">
                        <ul class="nav flex-column sub-menu">
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'email_marketing' }">Email
                                    Marketing</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'landing_page' }">Landing Page</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'webinar_scheduler' }">Webinar
                                    Scheduler</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'email_history' }">All Email
                                    History</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'email_list' }">List of Email</router-link>
                            </li>
                            <li class="nav-item">
                                <span class="nav-link">Email Management</span>
                                <ul class="nav flex-column sub-menu">
                                    <li class="nav-item">
                                        <router-link class="nav-link" :to="{ name: 'email_management' }">Email
                                            Management</router-link>
                                    </li>
                                    <li class="nav-item">
                                        <router-link class="nav-link" :to="{ name: 'scheduling' }">Scheduling</router-link>
                                    </li>
                                    <li class="nav-item">
                                        <router-link class="nav-link" :to="{ name: 'draftedEmail' }">Templates</router-link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </b-collapse>
                </li>
                <li class="nav-item" v-on:click="collapseAll">
                    <router-link class="nav-link" :to="{ name: 'ViewReferrals' }">
                        <i class="menu-icon new-menu-icon fa fa fa-sitemap"></i>
                        <span class="menu-title">Referrals</span>
                    </router-link>
                </li>
                <li class="nav-item" v-on:click="collapseAll">
                    <router-link class="nav-link" :to="{ name: 'ViewModules' }">
                        <i class="menu-icon new-menu-icon fa fa-video-camera"></i>
                        <span class="menu-title">Modules</span>
                    </router-link>
                </li>

                <li class="nav-item">
                    <span class="nav-link" v-b-toggle="'Seminar'">
                        <i class="fa fa-cubes new-menu-icon menu-icon"></i>
                        <span class="menu-title">Seminar Packing Items</span>
                        <i class="menu-arrow"></i>
                    </span>
                    <b-collapse accordion="sidebar-accordion" id="Seminar">
                        <ul class="nav flex-column sub-menu">
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'add_seminar' }">Add Seminar Items</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'view_seminar' }">View Seminar item</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'custom_modules', params: { id: 1 } }">Module
                                    1</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'custom_modules', params: { id: 2 } }">Module
                                    2</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'custom_modules', params: { id: 3 } }">Module
                                    3</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'custom_modules', params: { id: 4 } }">Module
                                    4</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'custom_modules', params: { id: 5 } }">Module
                                    5</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'custom_modules', params: { id: 6 } }">Module
                                    6</router-link>
                            </li>
                        </ul>
                    </b-collapse>
                </li>

                <li class="nav-item">
                    <span class="nav-link" v-b-toggle="'videos'">
                        <i class="fa fa-file-video-o new-menu-icon menu-icon"></i>
                        <span class="menu-title">Videos</span>
                        <i class="menu-arrow"></i>
                    </span>
                    <b-collapse accordion="sidebar-accordion" id="videos">
                        <ul class="nav flex-column sub-menu">
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'add_video' }">Add Videos Link</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'ViewVideos' }">View
                                    Videos </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'ArchiveVideos' }">Archive
                                    Videos</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'SeminarVideos' }">Seminar
                                    Videos</router-link>
                            </li>
                        </ul>
                    </b-collapse>
                </li>

                <li class="nav-item">
                    <span class="nav-link" v-b-toggle="'document'">
                        <i class="fa fa-file new-menu-icon menu-icon"></i>
                        <span class="menu-title">Documents</span>
                        <i class="menu-arrow"></i>
                    </span>
                    <b-collapse accordion="sidebar-accordion" id="document">
                        <ul class="nav flex-column sub-menu">
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'add_document' }">Add document</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'view_document' }">View documents</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'archive_document' }">Archive
                                    documents</router-link>
                            </li>
                        </ul>
                    </b-collapse>
                </li>

                <li class="nav-item">
                    <span class="nav-link" v-b-toggle="'web-content'">
                        <i class="fa fa-list-alt new-menu-icon menu-icon"></i>
                        <span class="menu-title">Web Content</span>
                        <i class="menu-arrow"></i>
                    </span>
                    <b-collapse accordion="sidebar-accordion" id="web-content">
                        <ul class="nav flex-column sub-menu">
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'home_page_content' }">HomePage
                                    Content</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'homepage_videos' }">HomePage
                                    Videos</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'seminar_content' }">Seminar
                                    Content</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'webinar_content' }">Webinar
                                    Content</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'about_us_content' }">About Us
                                    Content</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'contact_us_content' }">Contact us
                                    Content</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'scott_message' }">Dr Scott Message</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'subscribe_message' }">Subscriber
                                    Message</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'terms_of_service' }">Terms of
                                    Service</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'privacy_policy' }">Privacy Policy</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'register_content' }">Register Page
                                    Content</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'resources_content' }">Resources Page
                                    Content</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'email_content' }">Email Content</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'focus_action' }">Focus Action</router-link>
                            </li>
                        </ul>
                    </b-collapse>
                </li>
                <li class="nav-item">
                    <span class="nav-link" v-b-toggle="'Awards'">
                        <i class="fa fa-trophy new-menu-icon menu-icon"></i>
                        <span class="menu-title">Awards</span>
                        <i class="menu-arrow"></i>
                    </span>
                    <b-collapse accordion="sidebar-accordion" id="Awards">
                        <ul class="nav flex-column sub-menu">
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'add_awards' }">Add Awards</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'ViewAwards' }">View
                                    Awards</router-link>
                            </li>
                        </ul>
                    </b-collapse>
                </li>
                <li class="nav-item">
                    <span class="nav-link" v-b-toggle="'vendors'">
                        <i class="fa fa-file-video-o new-menu-icon menu-icon"></i>
                        <span class="menu-title">Vendors</span>
                        <i class="menu-arrow"></i>
                    </span>
                    <b-collapse accordion="sidebar-accordion" id="vendors">
                        <ul class="nav flex-column sub-menu">
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'add_vendor' }">Add Vendors</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{ name: 'ViewVendors' }">View Vendors</router-link>
                            </li>
                        </ul>
                    </b-collapse>
                </li>
            </ul>
        </nav>
    </section>
</template> 

<script>
import router from "../../router"
import API from '@/api'
export default {
    name: "sidebar",

    data() {
        return {
            collapses: [{ show: false }, { show: false }, { show: false }],
            getPermissionsData: [],
            url: null,
            Image: "",
            FirstName: ''
        };
    },
    methods: {
        logout() {
            var admin_user = JSON.parse(localStorage.getItem('user'));
            var citizen_user = JSON.parse(localStorage.getItem('spotterClientSettings'));
            if (citizen_user) {
                if (citizen_user['user_id'] === admin_user['id']) {
                    this.$session.clear();
                    localStorage.removeItem('userPermissions');
                    localStorage.removeItem('isLoggedin');
                    localStorage.removeItem('email');
                    localStorage.removeItem('password');
                    router.push({ name: "login" });
                } else {
                    API.logout(
                        data => {
                            this.$session.clear();
                            localStorage.removeItem('userPermissions');
                            localStorage.removeItem('isLoggedin');
                            localStorage.removeItem('email');
                            localStorage.removeItem('password');
                            router.push({ name: "login" });
                        },
                        err => {
                        }
                    )
                }
            } else {
                API.logout(
                    data => {
                        this.$session.clear();
                        localStorage.removeItem('userPermissions');
                        localStorage.removeItem('isLoggedin');
                        localStorage.removeItem('email');
                        localStorage.removeItem('password');
                        router.push({ name: "login" });
                    },
                    err => {
                    }
                )
            }
        },
        getAuthUser() {
            API.getAuthUser(
                '', data => {
                    this.url = data.image;
                    this.Image = data.Image;
                    this.FirstName = data.FirstName;
                    // console.log('adasdasd12', data);
                }
            )
        },
        getPermissions() {
            // this.getPermissionsData = JSON.parse(this.$session.get('userPermissions'));
            this.getPermissionsData = JSON.parse(localStorage.getItem('userPermissions'));
        },
        permissionExist(param) {
            var check = this.getPermissionsData.includes(param);
            if (check) {
                return true;
            } else {
                return false;
            }
        },
        collapseAll() {
            var exp_elm = document.getElementsByClassName("show");
            if (exp_elm.length > 0) {
                var elm_id = exp_elm[0].id;
                this.$root.$emit("bv::toggle::collapse", elm_id);
            }
        },
    },
    mounted() {

        const body = document.querySelector("body");
        // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
        document.querySelectorAll(".sidebar .nav-item").forEach(function (el) {
            el.addEventListener("mouseover", function () {
                if (body.classList.contains("sidebar-icon-only")) {
                    el.classList.add("hover-open");
                }
            });
            el.addEventListener("mouseout", function () {
                if (body.classList.contains("sidebar-icon-only")) {
                    el.classList.remove("hover-open");
                }
            });
        });


    }, beforeMount() {
        this.getPermissions();
        this.getAuthUser();
    },
    watch: {
        $route() {
            document.querySelector("#sidebar").classList.toggle("active");
        }
    }
};
</script>
